import { Plugin } from "prosemirror-state";
import { PluginKey } from "prosemirror-state";

export const DisallowCharactersPlugin = (regex, suggestionPluginKey) => {
    return new Plugin({
        key: new PluginKey("disallowCharacters"),
        props: {
            handleTextInput(view, from, to, text) {
                const { state } = view;

                const tagsState = state.tag$;
                if (!tagsState?.active) {
                    // Allow all input when tags are not active
                    return false;
                }

                // Check if the input contains disallowed characters
                if (regex.test(text)) {
                    // Block the input
                    return true;
                }

                return false;
            },
        },
    });
};
